import store from "store/store";
export class ZoomCommand {
    constructor(from, to) {
        this.from = from;
        this.to = to;
    }
    execute() {
        store.dispatchFn("Zoom", mutator(this.to));
    }
    undo() {
        store.dispatchFn("Zoom", mutator(this.from));
    }
}
function mutator(zoom) {
    return state => (Object.assign(Object.assign({}, state), { zoom: zoom }));
}
